import ApiService from '@/services/core/api.service'

const MarketingProgramService = {
  async get (query) {
    return ApiService.get(`agent/marketing-program-tracker?${query}`)
  }
}

export default MarketingProgramService
